import { storage } from '../firebase';
import { getWithApiName, postWithApiName } from '../axiosWithApiNames';
import { API_ENDPOINTS, buildHelpPortalApiUrl } from '../../config/apiConfig';

const API_NAME = 'helpPortalCommsAPI';

const isApiSuccess = (status) => {
  const normalized = (status || '').toLowerCase();
  return normalized === 'success' || normalized === 'sucesss';
};

const unwrapIssueTypesList = (data) => {
  if (!data || !isApiSuccess(data.status)) {
    return [];
  }
  return Array.isArray(data.details) ? data.details : [];
};

const unwrapIssueId = (data) =>
  data?.issueID ||
  data?.issueId ||
  data?.id ||
  data?.details?.[0]?.issueID ||
  data?.details?.[0]?.issueId ||
  data?.details?.[0]?.id ||
  data?.details?.issueID ||
  data?.details?.issueId ||
  data?.details?.id ||
  '';

const unwrapSelectedIssue = (data) => {
  if (!data || !isApiSuccess(data.status)) {
    return [];
  }
  const issue = Array.isArray(data.details) ? data.details[0] : [];
  return issue && typeof issue === 'object' ? issue : [];
};

export const getIssueTypes = async () => {
  try {
    const response = await getWithApiName(
      buildHelpPortalApiUrl(API_ENDPOINTS.ISSUE_TYPES),
      API_NAME,
      { includeApiKey: false },
    );
    return unwrapIssueTypesList(response?.data || []);
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const createLoggedIssue = async (issue) => {
  try {
    if (!issue) {
      return [];
    }
    const issueDetails = {
      ...issue,
      uploads: Array.isArray(issue.uploads)
        ? issue.uploads
        : issue.uploads
          ? [issue.uploads]
          : [],
    };
    const response = await postWithApiName(
      buildHelpPortalApiUrl(API_ENDPOINTS.CREATE_AND_EMAIL_ISSUE),
      issueDetails,
      API_NAME,
      { includeApiKey: false },
    );
    return unwrapIssueId(response?.data || {});
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const storeUploadedImage = async (files) => {
  try {
    if (!Array.isArray(files) || files.length === 0 || files.length > 3) {
      return [];
    }
    const allUrls = [];
    let filesUploaded = 0;
    return new Promise((resolve) => {
      files.forEach(async (file) => {
        try {
          const metaData = {
            contentType: 'image/jpeg',
            contentDisposition: 'inline',
          };
          const bucketRef = storage().refFromURL(
            'gs://balwin-60c4a.appspot.com',
          );
          const docRef = bucketRef.child(
            `helpPortalIssueImages/userIssue_${Date.now()}`,
          );
          await docRef.put(file, metaData);
          const docUrl = await docRef.getDownloadURL();
          allUrls.push(docUrl);
        } catch (error) {
          console.log(error);
        } finally {
          filesUploaded++;
          if (filesUploaded === files.length) {
            resolve(allUrls);
          }
        }
      });
    });
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getSelectedIssue = async (id) => {
  try {
    if (!id) {
      return [];
    }
    const response = await getWithApiName(
      buildHelpPortalApiUrl(API_ENDPOINTS.ISSUE),
      API_NAME,
      {
        params: { issueID: id },
        includeApiKey: true,
      },
    );
    return unwrapSelectedIssue(response?.data);
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const updateIssue = async (issue, id) => {
  try {
    if (!issue || !id) {
      return [];
    }
    const issueDetails = {
      ...issue,
      uploads: Array.isArray(issue.uploads)
        ? issue.uploads
        : issue.uploads
          ? [issue.uploads]
          : [],
    };
    const response = await postWithApiName(
      `${buildHelpPortalApiUrl(API_ENDPOINTS.UPDATE_AND_EMAIL_ISSUE)}?issueID=${encodeURIComponent(id)}`,
      issueDetails,
      API_NAME,
      { includeApiKey: false },
    );
    return response?.data || {};
  } catch (e) {
    console.log(e);
    return [];
  }
};
